import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import './admin.css';

const AdminVentas = () => {
  const [ventas, setVentas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filtro, setFiltro] = useState('pendiente'); // pendiente, todas

  useEffect(() => {
    cargarVentas();
  }, []);

  const cargarVentas = async () => {
    try {
      const res = await api.get('/ventas');
      setVentas(res.data);
    } catch (error) {
      console.error('Error cargando ventas:', error);
    } finally {
      setLoading(false);
    }
  };

  const aprobarPago = async (id) => {
    if (!window.confirm('¿Aprobar este pago?')) return;
    try {
      await api.put(`/ventas/${id}/aprobar`);
      cargarVentas();
    } catch (error) {
      alert('Error al aprobar');
    }
  };

  const rechazarPago = async (id) => {
    if (!window.confirm('¿Rechazar este pago?')) return;
    try {
      await api.put(`/ventas/${id}/rechazar`);
      cargarVentas();
    } catch (error) {
      alert('Error al rechazar');
    }
  };

  // Función para obtener la URL completa del comprobante
  const getComprobanteUrl = (url) => {
    if (!url) return null;
    // Si ya es una URL completa (empieza con http), la devolvemos tal cual
    if (url.startsWith('http')) return url;
    // Si es relativa (empieza con /), construimos la URL completa con el dominio de la API
    return `https://api.romanvalderrabanoelcatador.com${url}`;
  };

  const ventasFiltradas = filtro === 'todas' ? ventas : ventas.filter(v => v.estatus === 'pendiente');

  if (loading) return <div className="loading">Cargando...</div>;

  return (
    <div className="admin-page">
      <div className="page-header">
        <h1>💰 Ventas pendientes de aprobación</h1>
        <div className="filtros-group">
          <button 
            className={`filtro-btn ${filtro === 'pendiente' ? 'active' : ''}`}
            onClick={() => setFiltro('pendiente')}
          >
            Pendientes
          </button>
          <button 
            className={`filtro-btn ${filtro === 'todas' ? 'active' : ''}`}
            onClick={() => setFiltro('todas')}
          >
            Todas
          </button>
        </div>
      </div>

      <div className="table-responsive">
        <table className="admin-table">
          <thead>
            <tr>
              <th>Folio</th>
              <th>Cliente</th>
              <th>Total</th>
              <th>Método</th>
              <th>Estatus</th>
              <th>Comprobante</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {ventasFiltradas.map(v => {
              const comprobanteUrl = getComprobanteUrl(v.comprobante_url);
              return (
                <tr key={v.id}>
                  <td>{v.folio}</td>
                  <td>{v.cliente_nombre}</td>
                  <td>${v.total}</td>
                  <td>{v.metodo_pago}</td>
                  <td>
                    <span className={`status-badge ${v.estatus}`}>
                      {v.estatus}
                    </span>
                  </td>
                  <td>
                    {comprobanteUrl ? (
                      <a 
                        href={comprobanteUrl} 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="btn-small"
                      >
                        Ver comprobante
                      </a>
                    ) : (
                      <span className="pendiente">Sin comprobante</span>
                    )}
                  </td>
                  <td>
                    {v.estatus === 'pendiente' && (
                      <div className="acciones-cell">
                        <button 
                          className="btn-icon" 
                          onClick={() => aprobarPago(v.id)} 
                          title="Aprobar pago"
                        >
                          ✅
                        </button>
                        <button 
                          className="btn-icon" 
                          onClick={() => rechazarPago(v.id)} 
                          title="Rechazar pago"
                        >
                          ❌
                        </button>
                      </div>
                    )}
                    {v.estatus === 'pagado' && (
                      <span className="badge-success">Pagado</span>
                    )}
                    {v.estatus === 'rechazado' && (
                      <span className="badge-danger">Rechazado</span>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {ventasFiltradas.length === 0 && (
        <div className="no-data">
          <p>No hay ventas que mostrar</p>
        </div>
      )}
    </div>
  );
};

export default AdminVentas;